module.exports = __webpack_public_path__ + "img/backCard.c983e148.png";